import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=47897d7c&scoped=true&"
import script from "./HomeCover.vue?vue&type=script&lang=js&"
export * from "./HomeCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47897d7c",
  null
  
)

export default component.exports